module.exports = __webpack_public_path__ + "static/017-7b6f22cb6b5d03084c401e1eb5475039.jpg";